import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { openCookieSettings } from "../lib/analytics";
import { articleUiFor } from "../i18n/locales/articles-ui";

export function Footer() {
  const { t, i18n } = useTranslation();
  const year = new Date().getFullYear();
  const articleUi = articleUiFor(i18n.language);

  const cols = [
    {
      title: t("footer.markets"),
      links: [
        { to: "/gold", label: t("nav.gold") },
        { to: "/silver", label: t("nav.silver") },
        { to: "/bitcoin", label: t("nav.bitcoin") },
        { to: "/ethereum", label: t("nav.ethereum") },
        { to: "/oil/brent", label: t("nav.energy") },
        { to: "/forex/eur-usd", label: t("nav.forex") },
      ],
    },
    {
      title: t("footer.tools"),
      links: [
        { to: "/tools/gold-calculator", label: t("tools.goldCalc") },
        { to: "/tools/crypto-profit-calculator", label: t("tools.cryptoCalc") },
        { to: "/tools/if-you-invested", label: t("tools.investCalc") },
        { to: "/tools/currency-converter", label: t("tools.converter") },
        { to: "/compare", label: t("nav.compare") },
      ],
    },
    {
      title: t("footer.learn"),
      links: [
        { to: "/learn/what-moves-gold-prices", label: t("nav.gold") },
        { to: "/learn/what-affects-bitcoin", label: t("nav.bitcoin") },
        { to: "/learn/what-moves-oil-prices", label: t("nav.energy") },
        { to: "/learn", label: t("learn.title") },
        { to: "/articles", label: articleUi.nav },
      ],
    },
    {
      title: t("footer.legal"),
      links: [
        { to: "/legal/disclaimer", label: t("footer.disclaimer") },
        { to: "/legal/privacy", label: t("footer.privacy") },
        { to: "/legal/cookies", label: t("footer.cookie") },
        { to: "/legal/terms", label: t("footer.terms") },
        { to: "/methodology", label: t("footer.methodology") },
        { to: "/about", label: t("x.aboutTitle") },
      ],
    },
  ];

  return (
    <footer className="mt-24 border-t border-border bg-card" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-5">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary font-heading text-lg font-bold text-primary-foreground">M</span>
              <span className="font-heading text-lg font-semibold">MARDATIQ</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-muted-foreground">
              {t("footer.description")}
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="text-[11px] font-semibold uppercase tracking-[0.2em] text-foreground">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link to={l.to} className="text-sm text-muted-foreground transition-colors hover:text-foreground">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-border pt-8 text-xs text-muted-foreground sm:flex-row sm:items-center">
          <span>© {year} MARDATIQ. {t("footer.rights")}</span>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <button type="button" onClick={openCookieSettings} className="underline underline-offset-4 hover:text-foreground">{t("cookieConsent.settings")}</button>
            <span>{t("footer.dataNote")}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
